import { gql } from '@apollo/client';

export const UPDATE_REPORT = gql`
  mutation createUpdateReportProfile($save: ReportProfileInput) {
    createUpdateReportProfile(input: $save) {
      id
    }
  } 
`;
